<template>
  <div class="locationWrap">
    <h1 class="title">LOCATION</h1>
    <h4 class="buildingName">{{location.buildingName}}</h4>
    <strong class="companyAddress">{{location.address}}</strong>
    <naver-map/>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import NaverMap from "./NaverMap"

    export default {
        name: "location" ,
        components : {
          NaverMap
        } ,
        computed : {...mapGetters({
            location : 'informationStore/getInformationLocation'
        })},

    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/Location.vue